'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSettingsInputAntenna = function MdSettingsInputAntenna(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 1.6q7.6 0 13 5.4t5.4 13h-3.4q0-6.3-4.4-10.6t-10.6-4.4-10.6 4.4-4.4 10.6h-3.4q0-7.6 5.4-13t13-5.4z m1.6 22.2v5.5l5.7 5.7-2.3 2.3-5-5-5 5-2.3-2.3 5.7-5.7v-5.5q-2.5-1-2.5-3.8 0-1.7 1.2-2.9t2.9-1.2 2.9 1.2 1.2 2.9q0 2.8-2.5 3.8z m-1.6-15.4q4.8 0 8.2 3.4t3.4 8.2h-3.2q0-3.4-2.5-5.9t-5.9-2.5-5.9 2.5-2.5 5.9h-3.2q0-4.8 3.4-8.2t8.2-3.4z' })
        )
    );
};

exports.default = MdSettingsInputAntenna;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/settings-input-antenna.js
// module id = 1949
// module chunks = 168707334958949